export const invite = {
  extend: 'Flex',
  state: {
    role: 'guest'
  },
  props: {
    flow: 'column',
    align: 'center',
    height: '100%'
  },
  Form: {
    margin: 'auto',
    maxWidth: 'H',
    width: '100%',
    Hgroup: {
      margin: '- - C1',
      H: {
        text: '{{ members.invite.heading | polyglot }}'
      },
      P: null
    },
    InviteForm: {
      gap: 'A2'
    },
    P: {
      gap: 'E',
      margin: 'A2 - C1 -',
      color: 'gray7',
      maxWidth: 'G1',
      text: '{{ members.invite.body | polyglot }}'
    },
    ContinueButton: {
      tag: 'button',
      type: 'submit',
      margin: 'C1 - - -Y2',
      text: '{{ common.action.invite | polyglot }}',
      theme: 'primary'
    },
    CancelButton: {
      tag: 'button',
      type: 'button',
      margin: 'C1 - - Y1',
      text: '{{ common.action.cancel | polyglot }}',
      theme: 'secondary',
      onClick: async (ev, el) => {
        const isModal = el.getWindow('modal') === 'Invite'
        if (isModal) {
          await el.call('openRouterModal', '/settings', {
            key: '/project-account'
          })
        } else if (el.isCanvas()) {
          await el.call('closeRouterModal')
        } else {
          await el.router('/', el.getRoot())
        }
      }
    },
    onSubmit: async (ev, el, s) => {
      ev.preventDefault()

      const { name, email, role } = s
      const { projectId } = el.getRootState()

      try {
        if (projectId && email && role && name) {
          // NOTE: We need to be able to invite both registered and non-registered users
          // (the server builds the accept URL itself — no callbackUrl needed)
          await el.sdk.inviteMember(projectId, email, role, { name })
          el.call('openNotification', {
            title: el.call('polyglot', 'members.invite.success.title'),
            message: el.call('polyglot', 'members.invite.success.message').replace('{name}', name),
            type: 'success'
          })

          el.node.reset()
          s.set({
            role: 'guest'
          })
        } else {
          el.call('openNotification', {
            title: el.call('polyglot', 'members.invite.validation.title'),
            message: el.call('polyglot', 'members.invite.validation.message'),
            type: 'warning'
          })
        }
      } catch (err) {
        el.call('openNotification', {
          title: el.call('polyglot', 'members.invite.error.title'),
          message: `${err}`,
          type: 'error'
        })
        console.error(err)
      }
    }
  }
}
